(function () {
  var slugify = function (text, index) {
    var slug = text
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60);
    return slug ? 'article-' + slug : 'article-section-' + index;
  };

  var buildToc = function (nav) {
    if (nav.dataset.tocReady === 'true') return;

    var content = document.querySelector(nav.dataset.content);
    var list = nav.querySelector('.ma_l2_toc_list');
    if (!content || !list) return;

    var headings = Array.prototype.filter.call(content.querySelectorAll('h2, h3'), function (heading) {
      return heading.textContent.trim() !== '';
    });

    if (!headings.length) {
      nav.remove();
      return;
    }

    nav.dataset.tocReady = 'true';
    list.innerHTML = '';

    var links = [];

    var addLink = function (targetId, label, level) {
      var item = document.createElement('li');
      item.className = 'ma_l2_toc_item ma_l2_toc_item--' + level;

      var link = document.createElement('a');
      link.className = 'ma_l2_toc_link';
      link.href = '#' + targetId;
      link.textContent = label;

      item.appendChild(link);
      list.appendChild(item);
      links.push(link);
    };

    if (nav.dataset.introLabel) {
      if (!content.id) content.id = 'article-content';
      addLink(content.id, nav.dataset.introLabel, 'intro');
    }

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var id = slugify(heading.textContent, index + 1);
        var unique = id;
        var suffix = 2;
        while (document.getElementById(unique)) {
          unique = id + '-' + suffix;
          suffix += 1;
        }
        heading.id = unique;
      }
      addLink(heading.id, heading.textContent.trim(), heading.tagName.toLowerCase());
    });

    nav.hidden = false;

    var targets = links
      .map(function (link) {
        return document.getElementById(decodeURIComponent(link.hash.slice(1)));
      })
      .filter(Boolean);

    var setActive = function (target) {
      links.forEach(function (link) {
        var isActive = decodeURIComponent(link.hash.slice(1)) === target.id;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    var syncActive = function () {
      var line = window.innerHeight * 0.3;
      var current = targets[0];
      targets.forEach(function (target) {
        if (target.getBoundingClientRect().top <= line) current = target;
      });
      if (current) setActive(current);
    };

    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        syncActive();
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    syncActive();

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!target) return;

        event.preventDefault();

        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });

        if (window.history.replaceState) {
          window.history.replaceState(null, '', link.hash);
        }
      });
    });
  };

  var init = function () {
    document.querySelectorAll('[data-article-toc]').forEach(buildToc);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
